var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleBrocolli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 595,
    viewBox: "0 0 649 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.747 113.158C142.67 111.723 143.784 108.183 142.3 105.273C138.828 98.5858 132.26 86.373 124.452 73.5413C122.127 69.7211 117.097 68.6434 113.36 71.0996C109.703 73.503 108.645 78.4031 111.162 81.983C119.518 93.8683 128.572 104.064 131.97 110.633C133.491 113.482 136.922 114.57 139.747 113.158Z",
    fill: "url(#paint0_radial_1257_78348)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.386 105.446C141.883 106.061 141.242 106.581 140.477 106.957C137.652 108.368 134.221 107.28 132.699 104.431C130.703 100.572 126.754 95.4606 122.142 89.4901C118.903 85.2986 115.338 80.6837 111.892 75.7814C111.433 75.1291 111.093 74.433 110.866 73.7161C109.391 76.2245 109.374 79.4378 111.163 81.9834C114.61 86.8857 118.175 91.5006 121.413 95.6921C126.026 101.663 129.975 106.774 131.971 110.633C133.492 113.482 136.923 114.57 139.748 113.159C142.614 111.752 143.741 108.322 142.386 105.446Z",
    fill: "url(#paint1_radial_1257_78348)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2197 115.789C93.6062 106.961 105.614 106.459 117.791 107.272C124.678 107.71 133.124 108.675 139.121 104.51C142.405 102.207 143.388 98.8053 145.4 95.6062C147.233 92.6011 149.562 89.777 152.048 87.2913C161.353 77.5038 174.163 71.6108 187.56 70.6216C200.726 69.613 216.734 73.4884 226.56 82.6285C237.85 93.1458 245.582 107.011 250.112 121.653C255.321 138.164 256.634 155.694 256.457 172.984C256.407 179.925 256.073 186.935 254.462 193.652C249.223 215.859 227.967 230.729 205.692 231.46C189.404 232.021 176.925 246.118 162.674 252.285C159.325 253.7 155.515 255.075 151.942 255.565C148.156 256.107 144.35 254.394 140.827 252.913C132.629 249.554 125.117 244.673 118.32 239.016C93.0578 218.104 66.9203 185.506 69.1055 150.709C69.9037 138.465 75.0122 124.423 84.2197 115.789Z",
    fill: "url(#paint2_radial_1257_78348)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.492 148.794C255.193 151.769 254.736 154.718 254.041 157.613C248.803 179.82 227.546 194.69 205.272 195.422C194.876 195.78 186.032 201.652 177.289 207.457C172.333 210.747 167.409 214.016 162.254 216.247C158.905 217.661 155.095 219.037 151.522 219.527C147.918 220.043 144.296 218.515 140.917 217.09C140.746 217.018 140.576 216.946 140.407 216.875C132.209 213.516 124.696 208.635 117.9 202.978C98.4443 186.873 78.4698 163.836 71.3131 138.202C70.1091 142.394 69.3709 146.65 69.1063 150.708C66.9211 185.505 93.0585 218.104 118.321 239.015C125.117 244.672 132.63 249.553 140.828 252.913C140.997 252.984 141.168 253.056 141.339 253.128C144.717 254.553 148.339 256.08 151.943 255.564C155.516 255.075 159.326 253.699 162.675 252.284C167.831 250.053 172.754 246.784 177.71 243.494C186.453 237.689 195.297 231.818 205.693 231.46C227.967 230.728 249.224 215.858 254.462 193.651C256.073 186.934 256.408 179.924 256.457 172.983C256.54 164.93 256.299 156.825 255.492 148.794Z",
    fill: "url(#paint3_linear_1257_78348)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.303 108.411C180.263 120.616 200.176 134.005 212.386 131.044C224.596 128.083 227.189 112.87 224.229 100.665C221.27 88.4598 205.473 81.3396 193.263 84.3004C181.053 87.2612 174.344 96.2059 177.303 108.411Z",
    fill: "url(#paint4_radial_1257_78348)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.878 227.767C179.463 231.883 183.584 227.04 191.958 223.816C200.332 220.592 209.788 220.208 208.203 216.092C206.618 211.976 198.265 209.792 189.891 213.016C181.517 216.24 176.293 223.651 177.878 227.767Z",
    fill: "url(#paint5_linear_1257_78348)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.44 221.516C184.297 223.743 186.527 221.123 191.057 219.379C195.587 217.635 200.702 217.427 199.845 215.2C198.988 212.974 194.469 211.792 189.939 213.536C185.408 215.28 182.582 219.29 183.44 221.516Z",
    fill: "url(#paint6_linear_1257_78348)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.869 149.668C169.091 148.794 171.363 150.772 170.856 153.09C170.276 155.684 168.477 157.958 165.79 159.008C163.133 160.047 160.253 159.646 158.052 158.137C156.089 156.787 156.443 153.782 158.634 152.919C158.634 152.919 161.904 152.287 162.916 151.87C163.99 151.429 166.869 149.668 166.869 149.668Z",
    fill: "#661A39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.146 158.202C159.052 156.753 160.413 155.57 162.142 154.894C164.761 153.87 167.598 154.246 169.786 155.702C168.88 157.151 167.519 158.335 165.789 159.01C163.171 160.034 160.334 159.658 158.146 158.202Z",
    fill: "url(#paint7_linear_1257_78348)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.608 168.47C140.887 169.339 137.411 166.071 135.845 161.169C134.278 156.267 135.214 151.588 137.936 150.719C140.657 149.849 144.133 153.118 145.7 158.02C147.266 162.922 146.33 167.6 143.608 168.47Z",
    fill: "url(#paint8_radial_1257_78348)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.78 151.64C185.335 153.117 181.195 150.744 178.533 146.339C175.872 141.935 175.697 137.167 178.142 135.69C180.588 134.213 184.728 136.586 187.389 140.991C190.051 145.395 190.226 150.163 187.78 151.64Z",
    fill: "url(#paint9_radial_1257_78348)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6115 102.933C71.4524 97.799 78.5433 92.2029 86.1143 93.8953C90.841 95.7499 97.9679 97.5982 99.1175 92.2617C99.2733 91.5472 99.2909 90.6357 99.2143 89.5655C98.6376 87.2899 93.0988 82.1837 92.3458 82.0721C82.398 76.0815 81.7155 74.6409 72.9387 73.4485C58.1322 71.2808 39.0735 79.0984 35.86 94.9257C35.6486 98.9126 36.2077 102.1 37.3344 104.543C41.9648 114.885 56.065 112.966 65.6115 102.933Z",
    fill: "url(#paint10_linear_1257_78348)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6125 102.935C71.4534 97.8002 78.5444 92.2041 86.1153 93.8965C90.8421 95.7511 97.969 97.5994 99.1186 92.2629C90.0678 86.6632 88.55 85.1169 79.1908 83.8833C63.2959 81.5452 43.2194 89.022 37.3411 104.626C41.9656 114.887 56.0659 112.968 65.6125 102.935Z",
    fill: "url(#paint11_linear_1257_78348)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1257_78348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.967 340.059C387.362 357.681 400.662 376.022 418.266 379.059C435.802 382.135 454.754 369.374 458.586 351.961C447.882 366.56 449.605 388.829 462.514 401.351C475.422 413.873 497.816 414.972 512.177 403.851C526.539 392.73 530.869 370.725 521.9 355.107C537.67 363.78 559.306 360.188 571.621 346.949C583.897 333.642 585.774 311.861 575.874 296.871C565.974 281.881 545.267 275.047 528.13 281.174C546.03 286.33 567.107 275.824 573.728 258.45C580.349 241.077 571.721 219.309 554.892 211.521C538.062 203.733 515.652 210.794 506.391 226.943C524.219 222.34 535.572 201.322 530.669 183.634C525.767 165.945 506.705 153.949 488.335 155.841C469.965 157.734 454.008 172.34 449.088 190.106C455.027 173.31 447.475 152.936 432.121 144.022C416.766 135.109 395.209 138.839 383.517 152.36C371.824 165.88 371.194 187.584 382.212 201.471C378.409 182.324 356.123 170.172 337.127 174.99C318.132 179.808 304.378 198.73 303.195 218.188C302.013 237.645 312.067 256.759 327.043 269.188C342.019 281.617 361.412 287.927 380.254 290.067C372.69 298.092 367.943 309.256 369.507 320.168C371.072 331.081 380.115 340.887 391.054 341.63C402.024 342.265 413.061 331.779 389.967 340.059Z",
    fill: "url(#paint12_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.781 174.03C344.217 173.836 340.629 174.15 337.152 175.033C318.161 179.855 304.407 198.784 303.222 218.247C302.037 237.709 312.087 256.826 327.057 269.256C342.027 281.686 361.414 287.996 380.251 290.133C372.688 298.162 367.941 309.329 369.503 320.244C371.005 330.736 379.414 340.203 389.777 341.582C388.077 358.754 401.122 376.191 418.241 379.143C431.182 381.413 444.897 375.049 452.733 364.555C449.48 377.471 452.896 392.139 462.474 401.435C475.377 413.958 497.765 415.055 512.124 403.929C526.484 392.802 530.816 370.791 521.851 355.17C537.616 363.844 559.246 360.247 571.561 347.003C583.835 333.691 585.715 311.904 575.82 296.912C574.352 294.688 572.647 292.643 570.75 290.794C557.585 299.145 540.049 300.962 526.204 293.842C516.113 288.653 508.71 279.202 505.113 268.485C500.771 278.612 492.7 287.28 482.421 291.437C462.183 299.624 437.127 290.568 425.688 272.152C414.811 254.639 416.365 230.874 427.929 213.655C415.709 229.392 392.534 235.916 374.05 228.479C354.575 220.644 342.578 197.947 346.931 177.357C347.168 176.234 347.452 175.125 347.781 174.03Z",
    fill: "url(#paint13_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 26.6896,
    ry: 26.688,
    transform: "matrix(0.527343 0.849653 -0.848942 0.528487 499.502 267.406)",
    fill: "#4FBE42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 31.0715,
    ry: 31.0695,
    transform: "matrix(0.527343 0.849653 -0.848941 0.528487 539.704 305.746)",
    fill: "url(#paint14_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 56.566,
    ry: 56.5625,
    transform: "matrix(0.527343 0.849653 -0.848941 0.528487 470.337 236.278)",
    fill: "url(#paint15_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.049 275.995C482.572 292.224 447.946 284.046 431.543 257.617C418.062 235.896 421.067 208.578 437.138 190.321C437.023 190.391 436.91 190.461 436.796 190.532C410.275 207.042 402.131 241.943 418.605 268.486C435.079 295.029 469.933 303.163 496.453 286.653C501.271 283.654 505.482 280.048 509.049 275.995Z",
    fill: "url(#paint16_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.836 337.773C440.527 334.93 437.59 331.539 435.166 327.635C426.653 313.917 426.627 297.317 433.653 283.989L443.552 295.954C437.519 295.742 432.876 303.592 436.077 308.629C439.278 313.666 448.407 312.776 450.762 307.217C452.705 309.958 454.656 312.673 456.606 315.387C458.557 318.102 460.508 320.816 462.451 323.557C461.142 325.102 459.768 326.625 458.413 328.126C458.051 328.527 457.691 328.926 457.334 329.324C452.831 332.139 448.331 334.955 443.836 337.773Z",
    fill: "#35A328",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 43.8175,
    ry: 43.8172,
    transform: "matrix(0.527339 0.849655 -0.848939 0.528491 478.45 300.692)",
    fill: "url(#paint17_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.441 308.752C466.203 329.314 493.202 335.614 513.746 322.825C515.149 321.951 516.486 321.011 517.755 320.011C514.262 327.145 508.792 333.416 501.557 337.921C481.013 350.71 454.014 344.41 441.252 323.848C429.362 304.691 434.027 279.914 451.335 266.275C444.911 279.396 445.175 295.432 453.441 308.752Z",
    fill: "url(#paint18_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M386.355 547.978C349.337 547.978 319.328 544.315 319.328 539.796C319.328 535.277 349.337 531.613 386.355 531.613C423.374 531.613 453.383 535.277 453.383 539.796C453.383 544.315 423.374 547.978 386.355 547.978Z",
    fill: "url(#paint19_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.439 383.726C327.903 380.138 299.72 392.336 299.003 396.641C291.918 438.734 298.048 469.587 313.493 508.332C317.951 519.652 324.241 531.212 333.078 537.111C336.183 539.184 340.005 536.633 340.243 532.408C341.199 516.463 337.138 502.592 338.492 480.349C338.571 479.233 338.97 483.698 338.492 482.741C322.33 453.084 317.474 437.219 313.493 402.221C313.334 400.786 318.668 384.603 317.713 383.646C317.633 383.726 316.359 383.726 316.439 383.726Z",
    fill: "url(#paint20_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.545 280.006C336.581 306.155 318.031 337.326 306.408 370.889C298.128 395.045 293.351 421.194 299.083 446.067C304.815 470.94 322.569 494.14 347.17 500.677C358.396 503.706 371.452 502.67 379.891 494.698C387.932 487.044 389.923 474.847 388.808 463.765C387.693 452.684 384.19 442.001 383.076 430.92C381.165 411.786 387.136 391.936 399.317 377.028C411.498 362.12 429.65 352.314 450.031 350.958C448.916 346.255 447.802 341.631 446.607 336.927C441.671 341.471 434.267 343.704 427.898 341.471C421.529 339.319 416.832 332.224 418.345 325.607C419.857 318.99 428.137 314.605 434.029 317.874C429.889 309.662 425.749 301.451 421.688 293.24C417.31 299.378 412.692 305.676 405.845 308.785C398.998 311.815 389.445 310.141 386.42 303.205C384.429 298.581 385.942 293.16 388.41 288.775C391.515 283.354 396.053 278.73 401.705 276.099C396.769 274.425 392.311 271.555 389.684 266.931C386.26 263.423 382.917 259.836 379.493 256.328C368.825 267.17 360.147 279.926 360.545 280.006Z",
    fill: "url(#paint21_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.718 243.241C391.762 242.244 390.803 241.25 389.838 240.262C378.196 252.09 368.725 266.005 369.16 266.092C343.007 294.618 322.763 328.623 310.078 365.237C301.041 391.589 295.828 420.115 302.084 447.25C304.107 456.023 307.501 464.606 312.076 472.445C316.999 474.444 322.077 475.855 327.268 476.591C342.066 478.758 358.138 474.471 366.701 460.799C374.845 447.687 374.286 429.06 370.122 412.752C368.04 404.597 365.236 396.717 362.432 388.837C359.628 380.956 356.824 373.076 354.742 364.922C347.569 336.76 350.075 305.873 361.585 281.062C368.823 265.459 379.519 252.372 392.718 243.241Z",
    fill: "url(#paint22_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23 359.605L377.133 203.49L415.339 244.173L249.356 400.282L211.23 359.605Z",
    fill: "url(#paint23_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.023 203.605L401.613 229.786L235.751 385.759L211.226 359.596L377.023 203.605Z",
    fill: "url(#paint24_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.564 359.554L377.467 203.44L385.529 213.429L219.546 369.538L211.564 359.554Z",
    fill: "url(#paint25_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.397 182.563L394.294 187.422C386.731 194.517 386.358 206.395 393.445 213.968L405.906 227.245C412.994 234.818 424.858 235.194 432.421 228.099L437.524 223.241C445.087 216.146 445.46 204.267 438.373 196.694L425.912 183.418C418.824 175.845 406.881 175.463 399.397 182.563Z",
    fill: "url(#paint26_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.906 210.556L392.89 212.671C399.977 220.244 411.841 220.62 419.404 213.525L424.508 208.666C431.011 202.565 432.198 192.925 427.896 185.529L438.373 196.692C445.46 204.265 445.086 216.143 437.523 223.238L432.42 228.097C424.857 235.192 412.993 234.816 405.906 227.243L393.445 213.966C392.453 212.906 391.606 211.761 390.906 210.556Z",
    fill: "url(#paint27_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.851 188.77L364.98 214.908L403.186 255.59L431.062 229.373L392.851 188.77Z",
    fill: "url(#paint28_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.851 188.77L364.98 214.908L403.186 255.59L431.062 229.373L392.851 188.77Z",
    fill: "url(#paint29_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.289 214.615L390.158 241.096L417.711 215.183L431.062 229.37L403.185 255.588L364.98 214.905L365.289 214.615Z",
    fill: "url(#paint30_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.805 407.681L249.08 399.638L210.953 358.961L199.805 407.681Z",
    fill: "#FFECA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.892 407.299L235.817 385.489L249.079 399.638L199.805 407.681L199.892 407.299Z",
    fill: "url(#paint31_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.588 403.961L199.805 407.678L204.957 385.154L222.588 403.961Z",
    fill: "#F04534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.814 393.088C348.066 371.483 327.503 337.731 316.755 316.127C314.685 311.981 312.536 307.596 312.615 302.972C312.695 298.348 315.72 293.326 320.258 292.768C323.522 292.369 326.627 294.123 329.175 296.116C336.261 301.617 341.356 309.27 345.974 316.924C356.96 335.26 375.931 366.939 382.459 387.348C384.529 393.726 380.787 401.459 374.498 403.771C372.189 404.648 369.482 404.807 367.412 403.452C363.033 400.582 363.113 398.748 358.814 393.088Z",
    fill: "url(#paint32_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.586 279.549C298.145 265.686 304.706 252.225 315.202 241.536C320.538 236.12 327.834 231.086 335.851 231.75C341.09 232.18 345.807 235.119 348.835 238.83C352.635 243.51 354.261 249.71 352.125 255.166C350.069 260.63 343.882 265.067 337.314 265.048C330.667 265.021 324.503 259.993 323.87 254.226C314.398 262.223 305.804 270.962 296.586 279.549Z",
    fill: "url(#paint33_linear_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.474 319.464C370.168 322.873 365.947 324.146 364.073 322.282C362.182 320.443 363.351 316.211 366.657 312.802C369.963 309.393 374.184 308.12 376.058 309.984C377.966 311.797 376.78 316.055 373.474 319.464Z",
    fill: "url(#paint34_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.565 347.94C397.26 351.349 393.039 352.622 391.165 350.758C389.274 348.919 390.443 344.687 393.749 341.278C397.055 337.869 401.275 336.596 403.149 338.46C405.058 340.274 403.871 344.531 400.565 347.94Z",
    fill: "url(#paint35_radial_1257_78348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.541 334.634C379.54 334.854 379.75 335.034 379.962 334.994C380.352 334.963 380.742 334.932 381.124 334.859C381.438 334.776 381.702 334.549 382.042 334.484C382.653 334.345 383.219 334.544 383.358 335.156C383.456 335.556 383.257 336.123 383.017 336.477C382.769 336.789 382.293 336.946 381.893 337.155C380.056 338.014 378.086 337.6 377.292 336.211C376.499 334.822 377.102 332.46 378.559 331.454C378.908 331.21 379.545 331.088 379.908 331.261C380.515 331.563 380.366 332.164 380.116 332.696C379.607 333.829 379.53 333.998 379.541 334.634Z",
    fill: "#188055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.607 469.808C363.304 495.08 376.281 518.837 394.99 536.376C397.219 538.528 400.006 540.681 403.111 540.202C406.056 539.724 408.126 536.774 408.524 533.745C408.923 530.795 408.047 527.766 407.251 524.896C399.369 497.95 391.487 471.004 383.605 444.057C382.172 439.274 380.58 434.172 376.52 431.302C371.026 427.396 362.747 429.468 358.447 434.73C354.148 439.992 353.511 447.406 354.944 454.023C356.457 460.64 359.88 466.619 362.508 473.794C361.712 473.953 360.915 474.113 358.607 469.808Z",
    fill: "#B9E9B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.725 64.8928) rotate(166.369) scale(70.8851 70.8579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3715,
    stopColor: "#85575F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3343"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.555 70.0897) rotate(77.5271) scale(36.2381 36.2494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85575F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3343"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.396 84.6774) rotate(133.257) scale(204.867 204.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD7C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1257_78348",
    x1: 141.296,
    y1: 108.198,
    x2: 81.0518,
    y2: 233.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03E2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03E2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.462 79.6744) rotate(125.938) scale(71.6632 71.6588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC3BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F76050",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1257_78348",
    x1: 189.644,
    y1: 213.111,
    x2: 193.899,
    y2: 224.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A4645",
    stopOpacity: 0.688844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3528",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1257_78348",
    x1: 189.805,
    y1: 213.588,
    x2: 192.107,
    y2: 219.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3528",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1257_78348",
    x1: 166.188,
    y1: 139.206,
    x2: 166.158,
    y2: 139.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F75588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26161",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.785 159.58) rotate(162.281) scale(7.53954 7.53938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.97 143.648) rotate(148.871) scale(7.53929 7.53962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1257_78348",
    x1: 133.91,
    y1: 126.736,
    x2: 42.0728,
    y2: 83.4428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83CF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1257_78348",
    x1: 116.585,
    y1: 84.6809,
    x2: 34.7483,
    y2: 102.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB830"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(469.834 131.959) rotate(91.2751) scale(257.485 311.978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1257_78348",
    x1: 432.418,
    y1: 402.535,
    x2: 411.151,
    y2: 124.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#2F9822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD56F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9423 5.57658) rotate(67.4114) scale(53.9279 53.9303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DBD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A126"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9341 19.1197) rotate(40.8674) scale(101.665 101.664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1257_78348",
    x1: 457.657,
    y1: 153.146,
    x2: 406.697,
    y2: 300.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35A328"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.7097 82.0577) rotate(-110.982) scale(87.885 87.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61D154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1257_78348",
    x1: 514.408,
    y1: 329.92,
    x2: 322.42,
    y2: 295.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81E275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.696 545.152) rotate(180) scale(201.596 201.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1257_78348",
    x1: 340.933,
    y1: 455.426,
    x2: 275.318,
    y2: 479.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    stopColor: "#8BE085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E9B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.284 471.927) rotate(-45.3012) scale(246.183 246.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8EEB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384682,
    stopColor: "#ADEAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64617,
    stopColor: "#98E392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.008 567.701) rotate(-75.8563) scale(300.457 256.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#B9E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744913,
    stopColor: "#7CDD75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1257_78348",
    x1: 319.928,
    y1: 199.751,
    x2: 306.574,
    y2: 404.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1257_78348",
    x1: 312.618,
    y1: 199.395,
    x2: 300.159,
    y2: 389.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1257_78348",
    x1: 304.259,
    y1: 198.654,
    x2: 292.775,
    y2: 374.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED85F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.446 175.763) rotate(72.8038) scale(59.774 60.226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04331"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.446 175.769) rotate(72.8044) scale(59.765 60.2316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4574B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC3423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1257_78348",
    x1: 355.445,
    y1: 196.889,
    x2: 409.663,
    y2: 257.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348533,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF640D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1257_78348",
    x1: 420.117,
    y1: 222.004,
    x2: 391.835,
    y2: 187.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348533,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#FF9D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#FEBE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF974B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1257_78348",
    x1: 355.446,
    y1: 196.893,
    x2: 409.657,
    y2: 257.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.533493,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E43801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1257_78348",
    x1: 248.757,
    y1: 386.416,
    x2: 201.888,
    y2: 404.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1257_78348",
    x1: 358.858,
    y1: 305.495,
    x2: 371.512,
    y2: 404.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADEAA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1257_78348",
    x1: 345.646,
    y1: 244.517,
    x2: 261.238,
    y2: 285.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    stopColor: "#8BE085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E9B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.072 316.127) rotate(44.3535) scale(6.94851 6.94965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1257_78348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.163 344.603) rotate(44.3536) scale(6.94849 6.94964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1257_78348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 516,
    height: 516,
    fill: "white",
    transform: "translate(133 78.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBrocolli);
export default __webpack_public_path__ + "static/media/Apple&&Brocolli.7997807bd6890748ff63ccf81e7fcb82.svg";
export { ForwardRef as ReactComponent };